export const getCUrrentUser = async () => {
  return "";
};
